import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { EntitiesProvider } from './contexts/EntitiesContext';

const RootWithThemeProvider = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <EntitiesProvider>
          <App />
        </EntitiesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootWithThemeProvider />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
